export default __webpack_public_path__ + "static/media/icons8-training-100.06039db3.svg";